import Vue from 'vue';
import App from '@/App.vue';
import VueCustomElement from 'vue-custom-element';
import router from '@/router';
import SlideUpDown from 'vue-slide-up-down';
import { useStore } from '@/store';
import SearchForm from '@usedcarsni/html-widget-mainsite-search-form';
import '@usedcarsni/html-widget-mainsite-search-form/dist/index.css';

App.router = router;
Vue.use(VueCustomElement);

const store = useStore();
Vue.use(SearchForm, store);

Vue.component('slide-up-down', SlideUpDown);
Vue.customElement('get-updates-app', App);
